import siteModel from "./site-model";
import { defaultPaginationState } from "utils";

export default {
	currentSite: siteModel,
	isAddModalShowing: false,
	isEditModalShowing: false,
	isNew: false,
	isAddHazardToSiteModalShowing: false,
	isEditHazardToSiteModalShowing: false,
	isAddHazardousSubstanceToSiteModalShowing: false,
	isEditHazardousSubstanceToSiteModalShowing: false,
	searchFilter: "",
	pagination: defaultPaginationState,
	saveSuccessMessage: null,
};
